var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefualtImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "167px",
    height: "157px",
    viewBox: "0 0 167 157",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 12") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.06352276,0.72292652 C1.17495958,1.11539566 0.463456279,2.18836222 0.472431665,3.11772261 L0.472431665,3.11772261 C0.483038939,4.047083 1.21004518,4.48361312 2.09860836,4.09440776 L2.09860836,4.09440776 C2.98880343,3.70275457 3.70357051,2.63141989 3.69459513,1.69961167 L3.69459513,1.69961167 C3.68806757,0.998715643 3.27519983,0.578504405 2.69261571,0.578504405 L2.69261571,0.578504405 C2.498421,0.578504405 2.28627552,0.625013221 2.06352276,0.72292652 L2.06352276,0.72292652 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.02190961,0.666626373 C1.1235551,1.06317523 0.403076412,2.14266935 0.412051797,3.07855729 L0.412051797,3.07855729 C0.419395295,4.01281335 1.1512972,4.45097536 2.04720388,4.05605839 L2.04720388,4.05605839 C2.94637434,3.66195736 3.66930086,2.58327919 3.6627733,1.6465753 L3.6627733,1.6465753 C3.65869358,0.942415497 3.24337801,0.519756426 2.65753011,0.519756426 L2.65753011,0.519756426 C2.46170351,0.519756426 2.24629425,0.567081186 2.02190961,0.666626373 L2.02190961,0.666626373 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.03006905,0.58747979 C1.12518699,0.988108369 0.395732914,2.07494598 0.401444523,3.01491365 L0.401444523,3.01491365 C0.407156132,3.95488131 1.14558559,4.39385926 2.04965171,3.99649446 L2.04965171,3.99649446 C2.95534972,3.59831372 3.68806757,2.51229205 3.6831963,1.56987655 L3.6831963,1.56987655 C3.67990813,0.863268914 3.26377661,0.438977954 2.67384899,0.438977954 L2.67384899,0.438977954 C2.47557456,0.438977954 2.25853342,0.487118659 2.03006905,0.58747979 L2.03006905,0.58747979 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.73149393,1.36181079 C4.30628126,3.6774603 -0.0182227528,10.0116348 0.0307338964,15.5062027 L0.0307338964,15.5062027 C0.0780586573,20.9746604 4.4474396,23.610976 9.82777534,21.3997673 L9.82777534,21.3997673 C12.7717018,20.1905381 15.4210725,17.780239 17.2308366,14.9334099 L17.2308366,14.9334099 L10.7253139,11.0274852 L17.898279,2.24874209 C16.8155211,1.12600293 15.3060244,0.514044816 13.544401,0.514044816 L13.544401,0.514044816 C12.3678095,0.514044816 11.0794337,0.786570164 9.73149393,1.36181079 L9.73149393,1.36181079 Z",
    id: "path-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.548314471,8.71346761 L6.8449555,11.6990073 C8.48908297,9.78969795 9.41191581,7.58175307 9.60855908,5.07843641 L9.60855908,5.07843641 C9.60937429,2.55308926 8.92724498,1.00605914 7.5638023,0.441425787 L7.5638023,0.441425787 L0.548314471,8.71346761 Z",
    id: "path-9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-new",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy-3",
    transform: "translate(-645.000000, -316.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(648.000000, 319.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.73925218,119.192168 L78.6901089,153.651715 L78.6901089,153.651715 L163.34536,120.581747 C163.859787,120.38079 164.113904,119.800857 163.912947,119.28643 C163.824524,119.060077 163.656702,118.873667 163.440846,118.76204 L97.0236799,84.4151531 L97.0236799,84.4151531 L10.0289968,114.690725 C8.75220649,115.135069 8.07737533,116.530324 8.52171924,117.807114 C8.73148656,118.409866 9.16836756,118.906857 9.73925218,119.192168 Z",
    id: "Path-11",
    fill: "#D8D8D8",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#F8CCCE",
    opacity: 0.300000012,
    points: "0.804868467 35.3112887 6.41259527 37.5459966 6.41259527 114.769073 0.024036418 110.420514"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.5,
    y1: 49.5,
    x2: 95.2045481,
    y2: 14.4245055,
    id: "Stroke-5",
    stroke: "#4A4849",
    strokeWidth: 0.815944153,
    opacity: 0.200000003,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(8.842816, 39.702211)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-7"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#4A4849",
    mask: "url(#mask-2)",
    points: "-3.84187305 -4.39092187 8.00889984 -2.79656699 8.00889984 9.2059715 -3.84187305 7.61161663"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(14.554425, 37.254378)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-10"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    fill: "#4A4849",
    mask: "url(#mask-4)",
    points: "-3.9024161 -4.45268884 7.97691482 -2.85507019 7.97691482 9.17357852 -3.9024161 7.57595987"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(20.266034, 34.806546)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-13"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-12",
    fill: "#4A4849",
    mask: "url(#mask-6)",
    points: "-3.91277859 -4.53713906 7.99755821 -2.93544069 7.99755821 9.11931823 -3.91277859 7.51680392"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(14.361318, 51.941373)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-16"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-15",
    fill: "#F4CBCC",
    mask: "url(#mask-8)",
    points: "-4.2838156 -6.02958251 22.2123389 -2.46553845 22.2123389 28.4848552 -4.2838156 24.9208111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-20",
    transform: "translate(26.793587, 53.573261)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-19"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-18",
    fill: "#D12428",
    mask: "url(#mask-10)",
    points: "-3.76501111 -5.16223387 13.9222103 -2.78294072 13.9222103 16.7311796 -3.76501111 14.3518865"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-21",
    fill: "#F4CBCC",
    points: "49.8662033 44.0233692 49.8474366 47.4650217 88.3257309 31.1959112 88.4024297 27.6269715"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-22",
    fill: "#E3E3E2",
    points: "49.821408 51.7546033 49.8026412 55.1758571 88.1544643 39.1890633 88.2303471 35.64297"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-23",
    fill: "#E3E3E2",
    points: "49.777347 59.4373702 49.7585803 62.8365936 87.9839319 47.1313005 88.0589988 43.6080537"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-24",
    stroke: "#E3E3E2",
    strokeWidth: 0.815944153,
    points: "18.5580182 86.3380698 18.6787779 103.140808 87.3543494 76.4349557"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-29",
    transform: "translate(23.336704, 63.171484)",
    stroke: "#DC5256",
    strokeWidth: 0.815944153
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0998443662,33.5622852 C0.0998443662,33.5622852 4.37539173,27.7641861 13.0603013,15.989296 L23.7875191,20.3203276 L33.5992475,14.0865143 L40.4931597,19.4537949 L57.6084042,0.110206857",
    id: "Stroke-25"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-27",
    points: "12.7657455 27.1809492 20.9300827 11.1174567 26.7485804 15.2404225 38.0975476 8.55783986 42.6129826 12.8741844 53.4683036 14.3787855 62.3270093 1.05768121"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-32",
    transform: "translate(0.548547, 0.346958)",
    stroke: "#874446",
    strokeWidth: 3.375
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.55265918,32.4087087 C-0.0700757296,32.650166 -0.557426337,33.0486939 -0.897302452,33.5465581 C-1.2360582,34.0427811 -1.4311787,34.6423631 -1.4311787,35.2961756 L-1.4311787,109.253354 C-1.4311787,110.382567 -0.817590264,111.542785 0.248421263,112.230082 L4.9674618,115.27057 C5.95471496,115.906695 7.13995005,116.017424 8.11293007,115.652168 L94.2167724,83.2965232 C94.8331058,83.0652859 95.3292356,82.6657432 95.6751599,82.1645886 C96.0214688,81.6628766 96.2203195,81.0545816 96.2179885,80.3908454 L95.3543744,5.98425727 C95.3443039,5.11661188 94.9159416,4.3072102 94.2041751,3.81092568 L87.6397302,-0.76618233 C87.0781451,-1.15775177 87.1111638,-2.34945177 0.55265918,32.4087087 Z",
    id: "Stroke-30"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(69.548547, 32.777429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.8745406,42.5132229 L53.6338611,26.9630374 C53.4827365,26.4088771 53.0513996,25.9749755 52.498145,25.8205682 L24.7609354,18.079418 C24.326889,17.9582805 23.8768235,18.2119432 23.7556859,18.6459896 C23.7357565,18.7173986 23.7256523,18.7911906 23.7256523,18.8653285 L23.7256523,33.1825617 C23.7256523,33.8683936 23.2968327,34.4810417 22.6524445,34.7158378 L1.07320781,42.5786739 C0.428819566,42.8134699 3.43726398e-15,43.4261181 0,44.11195 L0,74.5580011 C-2.31213127e-15,75.2476653 0.433552275,75.8628716 1.08304036,76.0948242 L28.6338476,85.9340852 C29.0115948,86.0689906 29.4257957,86.0600471 29.7973678,85.9089622 L56.9148188,74.8827382 C57.5298271,74.6326698 57.9320349,74.0349428 57.9320349,73.3710381 L57.9320349,42.9425747 C57.9320349,42.7975384 57.9126998,42.6531493 57.8745406,42.5132229 Z",
    id: "Path-3",
    stroke: "#874446",
    strokeWidth: 3,
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-4",
    fill: "#D8D8D8",
    points: "29 54.1823671 1.30014657 44.5133709 30.8110298 33.5727612 56.3001466 44.2225714"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(28.168609, 26.000000) rotate(5.000000) translate(-28.168609, -26.000000) translate(11.168609, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.532419189,20.1932762 L14.5747821,0.678873914 C15.0282553,0.0486909073 14.6983206,0.298534844 15.3975098,0.606894572 L32.7399101,8.92823222 C32.8624011,8.99481144 32.9657895,9.09166609 33.0402121,9.20955633 C33.2635853,9.56339382 33.1813328,10.0231667 32.8633482,10.2796456 L32.7858143,10.3350835 L28.5529491,13.0069657 L28.4128043,39.9659711 C28.4100452,40.4956354 28.1506893,40.9880355 27.7223658,41.2904441 L27.6118155,41.3619997 L15.7967187,47.0784045 C15.4712719,47.2709291 13.2574536,46.3285119 9.15526379,44.2511528 L7.78451913,25.8647043 C7.54695112,25.875374 7.30712334,25.8341735 7.08263703,25.7404187 L6.94992703,25.6778538 L1.09564732,22.5898321 C1.02905008,22.5547034 0.964963912,22.5150076 0.903848158,22.4710293 C0.208874289,21.9709333 0.0240448863,21.0255727 0.458636059,20.3050729 L0.532419189,20.1932762 L14.5747821,0.678873914 L0.532419189,20.1932762 Z",
    id: "Path",
    fill: "#F8CCCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5421344,3.67862683 L6.96349553,26.1180871 L11.7605434,23.1729808 C12.5286093,22.7014334 13.5335145,22.941809 14.0050619,23.709875 C14.1375237,23.9256313 14.2179685,24.1692485 14.2400341,24.4214587 L16.0632471,45.2608794 L16.0632471,45.2608794 L31.0130307,40.743272 L27.993635,12.8145828 L32.4237286,9.82853508 L22.5421344,3.67862683 Z",
    id: "Path-15",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5582844,0.921579158 L33.0798211,8.86470736 C33.3598038,8.99931581 33.4776529,9.33540833 33.3430445,9.61539103 C33.3006264,9.70361965 33.2359167,9.77925039 33.1553122,9.83480667 L28.5529491,13.0069657 L28.5529491,13.0069657 L30.9007018,39.4593468 C30.9328965,39.8273332 26.4324163,42.1311262 17.3992614,46.3707258 L17.3992562,46.3707146 C17.0526352,46.5333969 16.6598462,46.5690137 16.2896164,46.4713331 C11.7346446,45.2695593 9.44717548,44.6111007 9.42720909,44.4959571 L9.40940865,44.3592302 L7.79107215,25.8643969 C7.55172707,25.8761094 7.30992311,25.8351603 7.08366926,25.7408494 L6.94992703,25.6778538 L0.0343921327,21.903238 C-0.00883730138,21.8804353 4.82042239,15.061136 14.5221712,1.44534026 C14.983019,0.798576309 15.8425504,0.577472748 16.5582844,0.921579158 Z",
    id: "Path",
    stroke: "#874446",
    strokeWidth: 2.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.59677122,
    y1: 26.4375013,
    x2: 13.7126774,
    y2: 22.1044344,
    id: "Path-16",
    stroke: "#874446",
    strokeWidth: 1.63188831,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-6",
    fill: "#FFFFFF",
    points: "1.30014657 44.8366136 1.30014657 74.9536121 29.3516987 84.8366136 56.3001466 73.8090007 56.3001466 44.8366136 28.8001466 54.0185434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.45145283,44.8366136 L1.30889892,73.2114868 C1.30365973,74.2543282 1.95970218,75.1859838 2.94329688,75.5325197 L29.3516987,84.8366136 L29.3516987,84.8366136 L29,54.1823671 L1.45145283,44.8366136 Z",
    id: "Path-6",
    fill: "#F8CCCE",
    opacity: 0.600000024
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(40.797208, 56.410809)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-10",
    fill: "#D32026",
    points: "0 3.34909049 6.11958115 1.27263171 8.6232713 2.47624351 8.6232713 10.5470215 0 14.1209316"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(2.447832, 0.249881)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 1.54599945,
    width: 1,
    height: 13.1409953
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    x: 3.26377661,
    y: 0,
    width: 1,
    height: 13.1409953
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefualtImage);
export default __webpack_public_path__ + "static/media/Defualt Image.bae7c1808a5eb95b7df4204eebdbc0e5.svg";
export { ForwardRef as ReactComponent };